import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Header from "./Header";
import ImageWithBasePath from "../core/common/imageWithBasePath";
import { ProductContext } from "../context/AppContext";
import { Link } from "react-router-dom";
import { all_routes } from "./router/all_routes";

const Food = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { getRegistration, userId } = useContext(ProductContext);
  const routes = all_routes;

  return (
    <>
      <div className="page-wrapper">
        <div className="content background-color_row">
          <>
            <Header />

            <div className="col-md-12">
              <div className="align-items-center justify-content-between mb-3 background-color_row">
                <div className="my-auto mb-1 mt-4">
                  <h3 className="page-title mb-1 text-center">Food</h3>
                </div>
              </div>
            </div>
            <div className="row d-flex background-color_row">
              <div className="col-md-3">
                <Link className="" to={`${routes.Canteen}`}>
                  <div className="card">
                    <div className="card-header_information">
                      <h5 className="card-title card-title_RightSide card-header_information_Text">
                      Canteen
                      </h5>
                    </div>
                  </div>
                </Link>
              </div>
              <div className="col-md-3">
                <Link className="" to={`${routes.orderhistory}`}>
                  <div className="card">
                    <div className="card-header_information">
                      <h5 className="card-title card-title_RightSide card-header_information_Text">
                      Order History
                      </h5>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </>
        </div>
      </div>
    </>
  );
};

export default Food
